export function filterInvoices(invoices = [], { customerId, searchQuery } = {}) {
  let result = [...invoices];

  if (customerId) {
    result = result.filter((invoice) => invoice.customerId === customerId);
  }

  const query = searchQuery?.trim().toLowerCase();
  if (query) {
    result = result.filter(
      (invoice) =>
        invoice.invoiceNumber?.toLowerCase().includes(query) ||
        invoice.companyName?.toLowerCase().includes(query)
    );
  }

  return result;
}
